import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ClipboardDocumentListIcon, ChartBarIcon } from '@heroicons/react/24/outline';

function QuestionnaireAnalyticsCard({ questionnaire, projectUuid }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleOpen = () => {
        navigate(
            `/project/${projectUuid}/questionnaire/${questionnaire.uuid}/results`,
            { state: { title: questionnaire.title } }
        );
    };

    const totalResponses = questionnaire.total_responses ?? 0;
    const completedResponses = questionnaire.completed_responses ?? 0;
    const completionRate = questionnaire.completion_rate != null
        ? Math.round(questionnaire.completion_rate)
        : null;

    return (
        <div
            className="flex flex-col border border-black px-4 py-4 w-full bg-white rounded-2xl h-full cursor-pointer hover:shadow-sm transition-shadow"
            onClick={handleOpen}
        >
            <div className="flex justify-between items-start mb-4">
                <div className="flex items-center gap-3">
                    <ClipboardDocumentListIcon className="w-10 h-10 shrink-0" />
                    <div>
                        <div className="text-base font-semibold text-gray-900 line-clamp-1">
                            {questionnaire.title}
                        </div>
                        <div className="text-sm text-gray-500 font-bold">{t('Questionnaires.AnalyticsCard.Label')}</div>
                        {questionnaire.status && (
                            <div className="text-xs text-gray-400 capitalize mt-0.5">{questionnaire.status}</div>
                        )}
                    </div>
                </div>

                <button
                    className="text-sm bg-black text-white rounded-xl h-fit px-3 py-2 whitespace-nowrap shrink-0"
                    onClick={(e) => { e.stopPropagation(); handleOpen(); }}
                >
                    <div className="flex items-center gap-1.5">
                        <ChartBarIcon className="w-4 h-4" />
                        <span>{t('Questionnaires.AnalyticsCard.AnalyticsButton')}</span>
                    </div>
                </button>
            </div>

            <div className="flex gap-6 border-t border-dashed pt-3 mt-auto text-sm text-gray-600">
                <div>
                    <span className="font-bold text-gray-900">{totalResponses}</span>
                    <span className="ml-1 text-gray-500">{t('Questionnaires.AnalyticsCard.Responses')}</span>
                </div>
                <div>
                    <span className="font-bold text-gray-900">{completedResponses}</span>
                    <span className="ml-1 text-gray-500">{t('Questionnaires.AnalyticsCard.Completed')}</span>
                </div>
                {completionRate !== null && (
                    <div>
                        <span className="font-bold text-gray-900">{completionRate}%</span>
                        <span className="ml-1 text-gray-500">{t('Questionnaires.AnalyticsCard.Rate')}</span>
                    </div>
                )}
                {questionnaire.questions_count != null && (
                    <div>
                        <span className="font-bold text-gray-900">{questionnaire.questions_count}</span>
                        <span className="ml-1 text-gray-500">{t('Questionnaires.AnalyticsCard.Questions')}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default QuestionnaireAnalyticsCard;
